import { render, staticRenderFns } from "./board-star.vue?vue&type=template&id=37c24603&scoped=true&"
import script from "./board-star.vue?vue&type=script&lang=js&"
export * from "./board-star.vue?vue&type=script&lang=js&"
import style0 from "./board-star.vue?vue&type=style&index=0&id=37c24603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c24603",
  null
  
)

export default component.exports